var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '@emotion/styled';
import { flex } from 'styled-system';
import { themeWidth, themeMaxWidth, themeHeight, themeMaxHeight, } from '../../../common/theme/system-utilities';
import Icon from '../../../common/components/Icon';
var ImgIconContainer = styled.div(themeWidth, themeMaxWidth, themeHeight, themeMaxHeight, flex);
ImgIconContainer.defaultProps = {
    themeWidth: 5,
    themeMaxWidth: 5,
    themeHeight: 5,
    themeMaxHeight: 5,
    flex: 'none',
};
var ImgIcon = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 100%;\n"], ["\n  width: 100%;\n  max-width: 100%;\n"])));
var StyledIcon = styled(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 100%;\n"], ["\n  width: 100%;\n  max-width: 100%;\n"])));
export var Img = function (_a) {
    var src = _a.src, alt = _a.alt, name = _a.name, title = _a.title, dataTestId = _a.dataTestId, props = __rest(_a, ["src", "alt", "name", "title", "dataTestId"]);
    return (React.createElement(ImgIconContainer, __assign({}, props), src ? (React.createElement(ImgIcon, { src: src, alt: alt })) : (React.createElement(StyledIcon, { name: name, title: title, dataTestId: dataTestId }))));
};
var templateObject_1, templateObject_2;
